export const Puchavichy = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            [28.546269400777703, 53.545439373576585],
            [28.531322557863575, 53.554648527913685],
            [28.51789511232505, 53.561097244990094],
            [28.506753188380117, 53.567035982788866],
            [28.498753859658393, 53.56788430576074],
            [28.48732624540196, 53.56873261171654],
            [28.47846984574562, 53.56924158712235],
            [28.475898632043936, 53.57297388679348],
            [28.47504156110938, 53.57755398551649],
            [28.4681849936336, 53.579589426227244],
            [28.46018566401341, 53.579589426227244],
            [28.444758385396312, 53.579759041818306],
            [28.43561629453012, 53.578910956523714],
            [28.42675989487384, 53.57908057537048],
            [28.419331945876763, 53.58162476840454],
            [28.41647504186352, 53.588408535111114],
            [28.41476089999452, 53.59417388083],
            [28.418760565253592, 53.596886712264165],
            [28.428188346431227, 53.60078610281272],
            [28.43790181792042, 53.60383754881104],
            [28.43847319854342, 53.60722778522904],
            [28.4264742036641, 53.60943129349715],
            [28.41590366124052, 53.611126221208565],
            [28.40533311881694, 53.61078724110894],
            [28.39904793196399, 53.61299056311361],
            [28.39790517071799, 53.618413635685954],
            [28.394762576393305, 53.624683194901365],
            [28.394476886081748, 53.62790233665788],
            [28.39047722172097, 53.630274178327454],
            [28.383620653346725, 53.63332349368591],
            [28.378478227739777, 53.63738890398673],
            [28.373907181857703, 53.6392520866479],
            [28.366764924070424, 53.63857457486307],
            [28.359908355696177, 53.634848068458666],
            [28.35847990413879, 53.633154093088024],
            [28.352766097010544, 53.632645886681075],
            [28.345909529534595, 53.63501746225489],
            [28.342481244898522, 53.63501746225489],
            [28.33619605804563, 53.630274178327454],
            [28.33448191527833, 53.62180270250013],
            [28.33162501216333, 53.61587165740457],
            [28.328482418736996, 53.61163468625551],
            [28.32305430192031, 53.61010927274572],
            [28.319626018182362, 53.60993977895407],
            [28.311340998250728, 53.61044825828793],
            [28.304770120188095, 53.61061775003867],
            [28.29991338489276, 53.61061775003867],
            [28.290485603715126, 53.60960078932982],
            [28.28648593935418, 53.60621074287894],
            [28.283057654717936, 53.60349851020101],
            [28.272201421982913, 53.60282042428349],
            [28.263345021428336, 53.60383754881104],
            [28.253631549939314, 53.60434610162315],
            [28.249060504955366, 53.6068887738337],
            [28.249917575889924, 53.611465198586984],
            [28.254488621771998, 53.615363243380614],
            [28.256774144264, 53.62010820283956],
            [28.255917073329556, 53.624513759613706],
            [28.246489292151978, 53.626885791740676],
            [28.2330618457151, 53.624852629508894],
            [28.22991925228871, 53.62078601065372],
            [28.227633729796764, 53.61654953324569],
            [28.21992009048813, 53.61366848521516],
            [28.211635070556497, 53.61163468625551],
            [28.204778503080604, 53.61044825828793],
            [28.199921766886916, 53.60993977895407],
            [28.191351056643896, 53.60993977895407],
            [28.183066036712262, 53.611126221208565],
            [28.175066707990368, 53.6124821143942],
            [28.164210475255345, 53.614515872535094],
            [28.155925455323768, 53.61688846708455],
            [28.15306855131047, 53.62078601065372],
            [28.157925287504156, 53.624683194901365],
            [28.161353571242103, 53.62569979234246],
            [28.172209803977125, 53.62959652288282],
            [28.174495327367367, 53.63552563956256],
            [28.175923778924755, 53.64162329033638],
            [28.17478101767881, 53.646703992768835],
            [28.170495662108294, 53.649074777527744],
            [28.163067713111104, 53.649413450183886],
            [28.154782694077767, 53.64416371779555],
            [28.15164009975308, 53.6412845551136],
            [28.14849750632652, 53.640268333122776],
            [28.14249800888689, 53.640776447178666],
            [28.13621282203394, 53.64196202283887],
            [28.131070395528866, 53.6426394796826],
            [28.12449951836453, 53.64179265692775],
            [28.119928472482286, 53.63908270985496],
            [28.10850085912432, 53.63738890398673],
            [28.102501362582984, 53.63721951971269],
            [28.090502367703493, 53.63772767049494],
            [28.083931490539157, 53.63959083819327],
            [28.079074754345527, 53.64060707650685],
            [28.072789567492748, 53.63976021294587],
            [28.06907559254489, 53.63772767049494],
            [28.060790572613257, 53.635864421033716],
            [28.053076934202977, 53.63501746225489],
            [28.043934843336956, 53.63654197581434],
            [28.039935178077656, 53.64060707650685],
            [28.041077939323657, 53.644333074185454],
            [28.0456489852059, 53.64772005970116],
            [28.046791746451902, 53.65449321414428],
            [28.0462203658289, 53.6661743485937],
            [28.046506056140345, 53.67277529693132],
            [28.044220533648343, 53.67683690520414],
            [28.039363797454712, 53.679375211187846],
            [28.03507844278232, 53.6812365388937],
            [28.02793618409669, 53.68377457975026],
            [28.019936854476498, 53.684112973641334],
            [28.010223382987476, 53.68428216956721],
            [28.00022422118684, 53.68698921193118],
            [27.999081459940896, 53.69223361184021],
            [27.998795769629453, 53.6971390720409],
            [27.996224556825894, 53.702213084499476],
            [27.993367653710948, 53.704073402276265],
            [27.988225227205874, 53.705933638348824],
            [27.979654516962682, 53.70762469020718],
            [27.971369497929345, 53.70813199251222],
            [27.96936966485066, 53.71083750150666],
            [27.96879828422766, 53.71557172415629],
            [27.963941548932326, 53.717600513930336],
            [27.95451376775469, 53.71962920531945],
            [27.9453716768885, 53.718445813900814],
            [27.935086824776477, 53.71793863595707],
            [27.925944733910285, 53.71827675526583],
            [27.918516784913265, 53.72267205893331],
            [27.91451712055232, 53.72605274971556],
            [27.907374861866685, 53.731630294966465],
            [27.904517958751683, 53.737207100316425],
            [27.90137536532535, 53.741938355038485],
            [27.900474801969892, 53.74502733603532],
            [27.895192518143006, 53.744298435856194],
            [27.888535451220207, 53.74331419393394],
            [27.8816703497493, 53.74331419393394],
            [27.873765082722514, 53.74368328742287],
            [27.86981244876, 53.74417540720867],
            [27.86232324813534, 53.74552870623813],
            [27.8542099474584, 53.74540568066135],
            [27.847968946937726, 53.744298435856194],
            [27.838399412506703, 53.742329928426614],
            [27.826333477867365, 53.74257599723035],
            [27.81905231089263, 53.74356025644295],
            [27.810730976565594, 53.74528265525589],
            [27.800329308432367, 53.74552870623813],
            [27.78847140744307, 53.74528265525589],
            [27.778693839361836, 53.74294509720312],
            [27.771640208462202, 53.73976054198914],
            [27.76148233052038, 53.73375219691218],
            [27.755895496664436, 53.730447241249635],
            [27.748277087759107, 53.728644428356176],
            [27.735579739882837, 53.72624055810769],
            [27.726437649016816, 53.72353603919879],
            [27.71831134612455, 53.718727576605374],
            [27.715771876190104, 53.71181444870092],
            [27.71831134612455, 53.70760590087923],
            [27.721358709147808, 53.704298889929134],
            [27.724913967056125, 53.699788910491236],
            [27.725421861043117, 53.6949777329952],
            [27.725421861043117, 53.69016600555972],
            [27.725421861043117, 53.68324818361185],
            [27.716279770176925, 53.67572752332626],
            [27.709677149245465, 53.6724180074375],
            [27.701042952366265, 53.670010923101245],
            [27.690885073526317, 53.66880732936244],
            [27.677679831663283, 53.66579819512958],
            [27.663966694914848, 53.66038121156049],
            [27.649745665077944, 53.65496353171159],
            [27.63857199826424, 53.65014723178473],
            [27.631969377332666, 53.64442716089309],
            [27.631461483345674, 53.639609657347876],
            [27.627906226335654, 53.63479160353131],
            [27.620795710518962, 53.632081206662974],
            [27.61317730161346, 53.63087652970478],
            [27.604543104734432, 53.62937063513857],
            [27.59438522679278, 53.62665989001829],
            [27.580646086512047, 53.62331037278068],
            [27.57045245202886, 53.6219531404966],
            [27.56109095034958, 53.621459590421296],
            [27.55048124946444, 53.620842645111],
            [27.544061511738505, 53.6208065873347],
            [27.5436161488916, 53.620804085862744],
            [27.53939047110015, 53.61849045745748],
            [27.535489845999336, 53.61482695362224],
            [27.532564377173742, 53.61232016297697],
            [27.52866375117469, 53.61077744831482],
            [27.521837657248113, 53.60884897558981],
            [27.51826208393959, 53.6086561236865],
            [27.511435989114887, 53.60884897558981],
            [27.506560207738744, 53.60904182714535],
            [27.504284842497782, 53.610584604685755],
            [27.501034321879786, 53.61116313239785],
            [27.495508436020884, 53.61019891585141],
            [27.491282758229545, 53.60749899270559],
            [27.49063265374656, 53.60113420500977],
            [27.493883175262738, 53.59746919511559],
            [27.499084009329408, 53.59476845812122],
            [27.506235155946513, 53.593225102247004],
            [27.512411145390104, 53.59283925433641],
            [27.517286927664372, 53.593610946634044],
            [27.52476312607388, 53.59573302698118],
            [27.53158922089858, 53.59554011465099],
            [27.537115106757483, 53.59438262430456],
            [27.54036562737548, 53.591874619411044],
            [27.541990888133455, 53.58801586001829],
            [27.545891514132734, 53.58550747774859],
            [27.549792139233546, 53.58222705996354],
            [27.556293181367664, 53.57875339966989],
            [27.562794223501783, 53.576437467558776],
            [27.56669484950089, 53.576244467134075],
            [27.570595474601816, 53.57701646248046],
            [27.57384599611794, 53.578946388107966],
            [27.575146204185558, 53.580683246006174],
            [27.576446413151473, 53.58319191512146],
            [27.576771464943704, 53.58589339207538],
            [27.57742156942652, 53.587437015744456],
            [27.579371881977067, 53.59013822136933],
            [27.582297350802662, 53.592260476130605],
            [27.589773549211998, 53.593610946634044],
            [27.593674175211106, 53.59303217899878],
            [27.596274592244413, 53.59148875970135],
            [27.596924695829102, 53.589752345270085],
            [27.59724974851963, 53.5870511149796],
            [27.596274592244413, 53.58531451873057],
            [27.595299435070956, 53.5835778511244],
            [27.596274592244413, 53.58106920491474],
            [27.59887500837948, 53.58010430130241],
            [27.602775634378588, 53.57991131815032],
            [27.606351207687112, 53.579332362874595],
            [27.60862657202972, 53.57720945884779],
            [27.60862657202972, 53.57450742686365],
            [27.60765141575473, 53.573542373476585],
            [27.604725946928966, 53.57199824234857],
            [27.601150373620385, 53.57026102762717],
            [27.59724974851963, 53.56813766809131],
            [27.59757480031203, 53.56659333959777],
            [27.605376051411895, 53.56485590283603],
            [27.610251832787867, 53.56408368545425],
            [27.616102771337523, 53.5623461455981],
            [27.61935329195535, 53.559643163775036],
            [27.61837813568019, 53.55597455493074],
            [27.614477510579377, 53.55385047812047],
            [27.606026154996584, 53.55230562796248],
            [27.600175217345225, 53.55230562796248],
            [27.59237396624536, 53.55056760431802],
            [27.586848080386403, 53.547091342876286],
            [27.58294745528542, 53.54458053167269],
            [27.5796969337693, 53.53704720490322],
            [27.57904682928637, 53.53260384543046],
            [27.57839672570168, 53.523522486583715],
            [27.57839672570168, 53.516758507371776],
            [27.577096516735992, 53.51134654664793],
            [27.571245579084632, 53.507673750958645],
            [27.56317128415577, 53.50024213218694],
            [27.5554740498809, 53.492816945827656],
            [27.551313383166644, 53.486875859990676],
            [27.548400916556375, 53.484152584781214],
            [27.54569648269802, 53.48093394243995],
            [27.546112549099973, 53.47808647884102],
            [27.548400916556375, 53.47598170851961],
            [27.55256158327063, 53.47622933429068],
            [27.5554740498809, 53.47721982132123],
            [27.55838651738935, 53.479200726555916],
            [27.567748018170278, 53.48254329413504],
            [27.571284584832597, 53.48291467427697],
            [27.57544525244532, 53.4822957057458],
            [27.576277385249227, 53.47981974024225],
            [27.574197052341162, 53.47474356012634],
            [27.57024441837865, 53.472143330160065],
            [27.565667684364087, 53.46830460407995],
            [27.565459651612173, 53.465456292403644],
            [27.571492618482807, 53.46335089615559],
            [27.57731755260147, 53.46359859509408],
            [27.583766586772356, 53.465456292403644],
            [27.58938348724081, 53.46805693206551],
            [27.595416454111444, 53.47177185573037],
            [27.60165745463206, 53.47523882360497],
            [27.60893862250498, 53.4782102852314],
            [27.61205912276546, 53.47994354210948],
            [27.61954832339012, 53.48217191074207],
            [27.626829490364855, 53.48217191074207],
            [27.637023124848042, 53.479200726555916],
            [27.640559692408658, 53.47684839132745],
            [27.643472159018756, 53.473381554419404],
            [27.645136426423164, 53.468923776724125],
            [27.648464959435387, 53.466323190172716],
            [27.654289893554107, 53.46471322323515],
            [27.659074660320357, 53.46496091475967],
            [27.663235327933137, 53.466323190172716],
            [27.670724528557912, 53.467809259140495],
            [27.677173562728626, 53.466570871768624],
            [27.680502096639145, 53.46260779013369],
            [27.67946192928673, 53.45913978986721],
            [27.678213729182573, 53.455671506321664],
            [27.678421762832784, 53.45207905722293],
            [27.68445472970336, 53.448981874100014],
            [27.691111797524286, 53.448114622224864],
            [27.695272464238542, 53.45034466224189],
            [27.69839296449885, 53.45232682192341],
            [27.699849198253105, 53.45406113596158],
            [27.70442593226778, 53.45678634258371],
            [27.708170532580084, 53.45765341739764],
            [27.715451699554706, 53.45852047450643],
            [27.723356967479788, 53.45864433798039],
            [27.731678301806767, 53.458272745405],
            [27.73563093487104, 53.45666247368973],
            [27.736671102223283, 53.451707407194306],
            [27.734382734766825, 53.44960132857864],
            [27.732926501910924, 53.44625616610557],
            [27.733134534662668, 53.44253900993726],
            [27.73230240185876, 53.43820191683841],
            [27.73022206805257, 53.43312075842829],
            [27.726477467740096, 53.43101375879411],
            [27.720236467219422, 53.43002219297057],
            [27.71337136664681, 53.43064192445479],
            [27.70962676633428, 53.43150953303143],
            [27.702761664863374, 53.43299682051111],
            [27.69464836418655, 53.43349257108184],
            [27.68861539731597, 53.43274894252187],
            [27.681334229443053, 53.43126164636806],
            [27.674261095220004, 53.43039403273133],
            [27.668228128349597, 53.43138558988039],
            [27.66573172814128, 53.43361650808845],
            [27.66573172814128, 53.43721051871444],
            [27.66697992824544, 53.44018464262655],
            [27.665939761791492, 53.444769342667314],
            [27.661779094178712, 53.445760564431566],
            [27.656084181316032, 53.446155497466634],
            [27.65348376428267, 53.446155497466634],
            [27.64925808649116, 53.445768308335744],
            [27.64243199256481, 53.44363870289283],
            [27.634110658237773, 53.43906937055419],
            [27.63369459183582, 53.43597123933523],
            [27.63535885834193, 53.43274894252187],
            [27.639935592356494, 53.42989824601756],
            [27.64430429272096, 53.42816294537238],
            [27.649921193189584, 53.42630361644916],
            [27.653457759851904, 53.42481609475578],
            [27.654389749382574, 53.42096317169256],
            [27.654389749382574, 53.41763063234316],
            [27.653990325169616, 53.41453589723125],
            [27.65146063968524, 53.41152029806142],
            [27.646667551824407, 53.40985369074616],
            [27.638679070259627, 53.40921877569724],
            [27.63561681945714, 53.40755207820331],
            [27.63641566788317, 53.40374223909174],
            [27.639611059790468, 53.400805255257126],
            [27.645032409598173, 53.39966755412132],
            [27.654458920557886, 53.397341822148235],
            [27.659984806416787, 53.39617890876292],
            [27.664210484208297, 53.39424064934724],
            [27.667135953033892, 53.39094540473138],
            [27.665510692275745, 53.38726218334449],
            [27.660959962692004, 53.38435415119318],
            [27.656409233108263, 53.38338476300106],
            [27.64763282663148, 53.38241535273772],
            [27.641781888081823, 53.38241535273772],
            [27.635605897739936, 53.38338476300106],
            [27.625529282297293, 53.3845480259688],
            [27.61935329195535, 53.3829970019728],
            [27.615452666854594, 53.378537491503494],
            [27.614802562371608, 53.374271436087554],
            [27.615777718646996, 53.36922918352434],
            [27.617728031197373, 53.36399236604706],
            [27.620653500921264, 53.36050079712862],
            [27.622278760781114, 53.35681494140556],
            [27.620328448230737, 53.35215866788718],
            [27.61740297940497, 53.348472090658106],
            [27.61285224982123, 53.34594951243622],
            [27.606026154996584, 53.3453673577626],
            [27.601424217379986, 53.34506209942987],
            [27.60165745463206, 53.34490939014961],
            [27.605194022192677, 53.34168019321453],
            [27.605376051411895, 53.33449901017002],
            [27.611651377457918, 53.32954119280487],
            [27.61378163872928, 53.32667860818327],
            [27.6121839427758, 53.32357725853967],
            [27.610186822609137, 53.32158909501197],
            [27.606725147593863, 53.319600838851215],
            [27.603396613683344, 53.31729434571537],
            [27.601798917729695, 53.31443093993903],
            [27.602730907260536, 53.311965074807745],
            [27.608056560439252, 53.31109005626962],
            [27.612450224985594, 53.3124423502822],
            [27.61644446531875, 53.31514680925807],
            [27.61830844438049, 53.31721480939416],
            [27.621303604505954, 53.318967994623335],
            [27.6281296993306, 53.319162167553884],
            [27.63365558518956, 53.319162167553884],
            [27.641131783598894, 53.31993884883195],
            [27.643732200632257, 53.322268808929834],
            [27.646007565873333, 53.327510752830335],
            [27.645357461390404, 53.33178149060069],
            [27.642106939874054, 53.33449901017002],
            [27.639181471048516, 53.33741044650702],
            [27.64048168001443, 53.34148612275152],
            [27.645682513182635, 53.34342678441794],
            [27.653158712490438, 53.34245646462506],
            [27.66193511896722, 53.34032168357089],
            [27.66876121379204, 53.33838088112202],
            [27.674937204133926, 53.33760453498195],
            [27.679487933717667, 53.33702226637081],
            [27.685013819576625, 53.33508131322935],
            [27.693790226951705, 53.33061678643412],
            [27.694115278744107, 53.32692834642097],
            [27.69314012246889, 53.324598641279636],
            [27.690539705435583, 53.322268808929834],
            [27.685663924059384, 53.321103844514255],
            [27.680463089992884, 53.319744679971734],
            [27.676237412201374, 53.317997118865264],
            [27.67688751668436, 53.315084357462126],
            [27.680138038200482, 53.31294820631052],
            [27.69086475812611, 53.312171397812676],
            [27.695090435019324, 53.312365601128135],
            [27.700616320878225, 53.31294820631052],
            [27.70646725942771, 53.314890166515454],
            [27.71296830156183, 53.316055300016615],
            [27.719144291903717, 53.31566692553787],
            [27.727920699278968, 53.31411339282067],
            [27.738972470996885, 53.30925823883729],
            [27.74677372209692, 53.30479100961287],
            [27.75685033753956, 53.301683095984004],
            [27.770502526290784, 53.30071182705598],
            [27.77635346484027, 53.301488844072935],
            [27.77992903814885, 53.30440253264533],
            [27.782854506974445, 53.30809291979955],
            [27.785779975799983, 53.311977193076814],
            [27.791955966141927, 53.315084357462126],
            [27.799432164551206, 53.314890166515454],
            [27.807233415651297, 53.31314240662874],
            [27.814384562268344, 53.309646671627206],
            [27.814384562268344, 53.30517948304623],
            [27.811134040752222, 53.301683095984004],
            [27.80658331116831, 53.29896348613647],
            [27.800407320826594, 53.29818642317122],
            [27.795856591242853, 53.29682652829058],
            [27.795206486759923, 53.29430089519593],
            [27.80105742530941, 53.290415013215124],
            [27.807233415651297, 53.28614013519234],
            [27.81210919702744, 53.283225200637105],
            [27.813409405993184, 53.280310067232904],
            [27.811134040752222, 53.277006008264834],
            [27.80560815489315, 53.27661727909492],
            [27.800082269034192, 53.277006008264834],
            [27.796506695725668, 53.277006008264834],
            [27.790655757176182, 53.27525669754738],
            [27.790005653591493, 53.270591518961],
            [27.794231330484706, 53.26650906952386],
            [27.79683174751807, 53.26437048816064],
            [27.800082269034192, 53.25775965154935],
            [27.80138247710181, 53.252703615941584],
            [27.803657842342716, 53.24531295128918],
            [27.80625825937608, 53.240255444561285],
            [27.808533623718915, 53.23480823083713],
            [27.809183728201674, 53.22897116099546],
            [27.808858676409443, 53.22332790399719],
            [27.804958050410335, 53.2188516885534],
            [27.80235763337697, 53.215932165149184],
            [27.798131956483815, 53.21398570620266],
            [27.797156800208597, 53.21028718984991],
            [27.799107112758975, 53.206977720511304],
            [27.807883520134226, 53.20405738785439],
            [27.81535971854356, 53.20327859919149],
            [27.818935291852085, 53.20327859919149],
            [27.827061594744407, 53.20483616290346],
            [27.835187897636672, 53.20658835421443],
            [27.844289356804154, 53.20950851386135],
            [27.855016076729783, 53.21281778773795],
            [27.86373566296828, 53.21455830696533],
            [27.86373566296828, 53.220129439733455],
            [27.866860401480096, 53.22280208897581],
            [27.909267560966327, 53.22333659838057],
            [27.928462380173528, 53.223069344511885],
            [27.939175767303652, 53.22413835051725],
            [27.943639679206683, 53.22707798011527],
            [27.939175767303652, 53.23055182780763],
            [27.931140726956073, 53.23268944010988],
            [27.925784033390926, 53.235094126176534],
            [27.92042733892748, 53.238834480649814],
            [27.919534557265536, 53.24391015336283],
            [27.923552077439297, 53.24818393671103],
            [27.932926291178262, 53.24898522414037],
            [27.938282985641706, 53.24898522414037],
            [27.942300505815524, 53.245512872206916],
            [27.946318025989285, 53.24417727715951],
            [27.951674719554262, 53.24444439928874],
            [27.955692240626547, 53.24631420911925],
            [27.958816978240066, 53.254860869327445],
            [27.957031414017706, 53.260735708116215],
            [27.95747780484868, 53.265541794476235],
            [27.963280890143153, 53.267143703055694],
            [27.96997675709929, 53.26741068180519],
            [27.97801179744704, 53.2682116085893],
            [27.98560044786194, 53.27168211831264],
            [27.98560044786194, 53.27488541537883],
            [27.981582926789883, 53.27968991146105],
            [27.98113653595891, 53.2828926084664],
            [27.98426127357243, 53.28689564220963],
            [27.990064358866732, 53.28903044038378],
            [27.994081879040664, 53.29169878823916],
            [27.994974661600907, 53.296234596684656],
            [27.99363548820969, 53.29916927498056],
            [27.99542105243188, 53.30343753756466],
            [28.002563311117513, 53.3061049855184],
            [28.009705569803145, 53.30770537409131],
            [28.01729421931975, 53.30743864700719],
            [28.024882868836357, 53.3058382484362],
            [28.033810691744293, 53.30263727079165],
            [28.041845732091872, 53.29836892821925],
            [28.051219946729134, 53.29223243738147],
            [28.06282611641967, 53.286361925865265],
            [28.072200331056763, 53.28262572585851],
            [28.0838065007473, 53.276220051826044],
            [28.095859062166937, 53.270347340178375],
            [28.10398020090514, 53.26625722722696],
            [28.105825909538225, 53.266671202913756],
            [28.123992961306215, 53.27001432020484],
            [28.139365082032953, 53.27335717759183],
            [28.151942271718553, 53.27419285011996],
            [28.157532133801112, 53.267507006743074],
            [28.17569918466978, 53.265835381997476],
            [28.198058632100185, 53.265835381997476],
            [28.22321301147133, 53.260820117454614],
            [28.234392734737014, 53.25747628070593],
            [28.252559786505003, 53.254132182254466],
            [28.27212430379376, 53.25162393709513],
            [28.29308628570368, 53.25162393709513],
            [28.31544573313414, 53.25162393709513],
            [28.33501025042284, 53.252460035002684],
            [28.33780518146392, 53.25998418232422],
            [28.33640771594338, 53.26834279438452],
            [28.353177301291453, 53.27001432020484],
            [28.37413928410075, 53.265835381997476],
            [28.409075921216868, 53.264163692500574],
            [28.420255644482552, 53.27001432020484],
            [28.43702523073, 53.27586414751255],
            [28.43702523073, 53.290067538985795],
            [28.43283283416804, 53.306771366805265],
            [28.42584550656494, 53.31345106871203],
            [28.427242972984857, 53.323468662848654],
            [28.42165311090247, 53.32847657813164],
            [28.411870851358742, 53.33181486156673],
            [28.39929366257246, 53.33181486156673],
            [28.38252407722456, 53.33682179658871],
            [28.36715195649765, 53.34266247869061],
            [28.36575449097711, 53.34516538367558],
            [28.35876716337401, 53.3543414435029],
            [28.3573696978533, 53.36184765924219],
            [28.35876716337401, 53.37352136751724],
            [28.36295955993586, 53.38185777261822],
            [28.376934215142, 53.384358376238254],
            [28.388113939306947, 53.384358376238254],
            [28.40069112809323, 53.39352599772667],
            [28.40348605913448, 53.40185848628022],
            [28.41047338673758, 53.41352123002093],
            [28.418858179861218, 53.42268257064427],
            [28.418858179861218, 53.429344125131365],
            [28.418858179861218, 53.43933449858838],
            [28.4174607134413, 53.445993442343536],
            [28.40628099017573, 53.449322523915384],
            [28.39649873153138, 53.449322523915384],
            [28.369946886639582, 53.45265134378457],
            [28.35457476681222, 53.45847615015424],
            [28.33640771594338, 53.46596401432788],
            [28.34898490472966, 53.4692915301801],
            [28.36295955993586, 53.470955189630274],
            [28.36854942201819, 53.47760917722178],
            [28.372741817680833, 53.486756706956555],
            [28.38252407722456, 53.4884196829222],
            [28.392306334969362, 53.48343056077192],
            [28.392306334969362, 53.48010415378366],
            [28.39510126601067, 53.4751140540705],
            [28.40348605913448, 53.4751140540705],
            [28.41606324881991, 53.47760917722178],
            [28.423050575523632, 53.48426212249899],
            [28.43283283416804, 53.48925114572393],
            [28.447478273003924, 53.49852916888614],
            [28.457316429909383, 53.507572456403864],
            [28.475203988573355, 53.51076374385167],
            [28.490408412718125, 53.51076374385167],
            [28.50203532566985, 53.50544479803898],
            [28.510979104102546, 53.50544479803898],
            [28.519922884333823, 53.50544479803898],
            [28.527972284293583, 53.507572456403864],
            [28.54675422143032, 53.51076374385167],
            [28.557486755909224, 53.51235929764351],
            [28.57090242490716, 53.51608202326679],
            [28.566430535241125, 53.52193135954468],
            [28.55659237833561, 53.52193135954468],
            [28.540493575718074, 53.52086790403064],
            [28.521711639480657, 53.519804421536946],
            [28.506507215335887, 53.52458988231729],
            [28.506507215335887, 53.53043804318128],
            [28.512767860148756, 53.536816934454066],
            [28.52081726190727, 53.54106899563777],
            [28.544071086911288, 53.54532062874415],
            [28.546269400777703, 53.545439373576585],
          ],
        ],
      },
      properties: {
        shapeName: "Puchavičy",
        shapeISO: "",
        shapeID: "67162791B58974730621112",
        shapeGroup: "BLR",
        shapeType: "ADM2",
      },
    },
  ],
};
